import React from "react";
import Button from "features/components/button";
import {historyObject} from "historyObject";
import "./index.scss";

function HelpButton() {
    return <div className="help-button"><Button title={""} onClick={() => historyObject.push("/help")} status={"fab"} icon={"messanger"} /></div>
}
export default HelpButton;